import React from 'react';
import { SetupAreaVersionStatus, useSetupAreasAdminService } from 'nekst-api';
import { useDataLoaderNew } from 'data-loader';
import {
  BaseInputProps,
  Dropdown,
  LoadingAnimation,
  MultiSelectDropdown,
  Option
} from 'ui-builder';

export interface SetupAreaDropdownProps extends BaseInputProps {
  exceptIds?: number[];
}

function useSetupAreaDropdownOptions(exceptIds?: number[]) {
  const setupAreaService = useSetupAreasAdminService();

  const { data } = useDataLoaderNew(
    async () => {
      return setupAreaService.getSetupAreas();
    }
  );

  let options: Option<string>[] | undefined = undefined;

  if (data) {
    const filteredOptions = data
      .filter((item) => {
        if (exceptIds && exceptIds.includes(item.id)) {
          return false;
        }

        return item.versions && item.versions.length > 0;
      });

    options = [];

    filteredOptions.forEach((setupArea) => {
      setupArea.versions.forEach((version) => {
        if (version.status !== SetupAreaVersionStatus.ARCHIVED) {
          options!.push({
            value: `${setupArea.id}:${version.version}`,
            label: `${setupArea.name} (${version.version})`
          });
        }
      });
    });
  }

  return {
    options
  };
}

export function SetupAreaAndVersionDropdown(props: SetupAreaDropdownProps) {

  const { options } = useSetupAreaDropdownOptions(props.exceptIds);

  if (options) {

    return (
      <Dropdown
        {...props}
        options={options}
      />
    );
  } else {
    return (<LoadingAnimation />);
  }
}

export interface SetupAreaMultiDropdownProps extends BaseInputProps<string[]> {
  exceptIds?: number[];
}

export function parseSetupAreaIdWithVersion(value: string) {
  const parts = value.split(':');
  if (parts.length === 2) {
    const areaId = parseInt(parts[0], 10);
    const version = parts[1];
    if (!isNaN(areaId) && version) {
      return {
        setupAreaId: areaId,
        setupAreaVersion: version
      };
    } else {
      throw new Error();
    }
  } else {
    throw new Error();
  }
}

export function SetupAreaVersionMultiDropdown(props: SetupAreaMultiDropdownProps) {

  const { options } = useSetupAreaDropdownOptions(props.exceptIds);
  if (options) {

    return (
      <MultiSelectDropdown
        {...props}
        options={options}
      />
    );
  } else {
    return (<LoadingAnimation />);
  }
}
